const to2digit = (value: number) => {
    return value < 10 ? ('0' + value) : value;
};

export class EnvironmentService {

    mainServer: string = location.protocol + '//' + location.host;

    timeZoneOffset: string = EnvironmentService._getTimeZoneOffset();

    /** Возвращает TimeSpan часового пояса браузера */
    private static _getTimeZoneOffset(): string {
        const timeZoneOffset = new Date().getTimezoneOffset();
        const absTimeZoneOffset = Math.abs(timeZoneOffset);
        const sign = (timeZoneOffset > 0 ? '-' : '');
        const hours = to2digit(Math.floor(absTimeZoneOffset / 60));
        const minutes = to2digit(absTimeZoneOffset % 60);
        return sign + hours + ':' + minutes;
    }

}